var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('read-base-seo',{attrs:{"loading":_vm.loading,"pageContent":_vm.piscine.content},on:{"edit":_vm.edit}},[_c('edit',{ref:"edit"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }